module.exports = __webpack_public_path__ + "static/1-8cb5f32a33455396605a89d000ede667.png";